import { API_HELPER } from '@/helpers/api.js';
import { authHeader } from '@/helpers/auth-header.js';

const EXPERIENCES_API = 'experiences';
const PRICE_PERIODS_API = 'price-periods';
const PRICE_SCHEDULE_API = 'price-schedule';

// The endpoints may answer with the bare DTO or wrapped in { data, success, message }
function unwrap(response) {
  if (response && !Array.isArray(response) && typeof response === 'object' && 'data' in response && 'success' in response) {
    return response.data;
  }
  return response;
}

export const pricePeriodsService = {
  getList(experienceId) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API, experienceId, PRICE_PERIODS_API]);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions, true, true).then(unwrap);
  },

  create(experienceId, data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API, experienceId, PRICE_PERIODS_API]);
    const requestOptions = {
      method: 'POST',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions, true, true).then(unwrap);
  },

  update(experienceId, id, data) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API, experienceId, PRICE_PERIODS_API, id]);
    const requestOptions = {
      method: 'PUT',
      headers: { ...authHeader(), "Content-Type": "application/json" },
      body: JSON.stringify(data)
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions, true, true).then(unwrap);
  },

  delete(experienceId, id) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API, experienceId, PRICE_PERIODS_API, id]);
    const requestOptions = {
      method: 'DELETE',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, null, requestOptions, true, true);
  },

  // from / to: 'yyyy-MM-dd' (the API allows at most 731 days)
  getSchedule(experienceId, from, to) {
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, EXPERIENCES_API, experienceId, PRICE_SCHEDULE_API]);
    const requestOptions = {
      method: 'GET',
      headers: { ...authHeader() }
    };
    return API_HELPER.loggedApiCall(url, { from, to }, requestOptions, true, true).then(unwrap);
  }
};

// Turns an API error body ({ errors: { Field: [msg] }, message }) into a list of readable messages
export function pricePeriodErrorMessages(error, fallback) {
  if (error && typeof error === 'object') {
    if (error.errors && typeof error.errors === 'object') {
      const messages = [];
      Object.values(error.errors).forEach(value => {
        (Array.isArray(value) ? value : [value]).forEach(message => { if (message) messages.push(message); });
      });
      if (messages.length) return messages;
    }
    if (error.error) return [error.error];
    if (error.message) return [error.message];
  }
  if (typeof error === 'string' && error) return [error];
  return [fallback];
}
